import { Box, useMediaQuery } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import SortByList from '../../../../components/PageHelpers/Sort'
import { customerAdminSelectUsers } from '../../../../redux/features/users/customerAdmin/customerAdminSlice'
import { customerAdminFilterBySummary, customerAdminGetByUserTypes, customerAdminSearchUsers, customerAdminUsersSortBy } from '../../../../redux/features/users/customerAdmin/customerAdminThunk'
import TitleWithCountV2 from '../../../../components/PageHelpers/TitleWithCountV2'
import UsersList from '../../../../images/UsersList.svg'
import IconBtnV2 from '../../../../components/Buttons/IconBtnV2'
import FilterSort from '../../../../images/FilterSort.svg'
import SearchBarToggle from '../../../../components/PageHelpers/SearchBarToggle'
import UseTranslation from '../../../../hooks/UseTranslation'
import FormModalContainer from '../../../../components/Modals/FormModalContainer'
import DropDownBatchButton from './DropDownBatchButton'
import OfoqThemeBtn from '../../../../components/Buttons/OfoqThemeBtn'
import SummariesBtn from '../../../../components/PageHelpers/SummariesBtn'
import ActiveFilters from '../../../../components/PageHelpers/ActiveFilters'
import MenuListMultiSelect from '../../../../components/Forms/MenuListMultiSelect'

const Mobile = () => {
  const users = useSelector(customerAdminSelectUsers)
  const [openFilter, setOpenFilter] = useState(false)
  const { t } = UseTranslation()
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(customerAdminGetByUserTypes({ queries: 'clear' }))
    setOpenFilter(false)
  }
  const [searchBarExpanded, setSearchBarExpanded] = useState(false)
  const [selectedUserTypes, setSelectedUserTypes] = useState([])

  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))

  useEffect(() => {
    if (users?.activeFilters?.length !== selectedUserTypes.length) {
      setSelectedUserTypes(users?.activeFilters || [])
    }
  }, [users?.activeFilters])

  const isFilteredArraysNotEmpty = users?.activeFilters?.length > 0

  return (
    <Box sx={styles.employeeContainer}>
      <Box sx={styles.firstRow}>
        {!searchBarExpanded && (
          <TitleWithCountV2
            icon={<img src={UsersList} alt="UsersList" />}
                iconSize='xl'
            store={users}
            title={t?.Users}
            customCount={t?.Employees}
            withCount
            customStyle={styles.titleHeader}
          />
        )}
        <Box sx={styles.searchSortFilter}>
          <Box sx={isXsScreen && styles.filterWithSearch}>
            {(isXsScreen && !searchBarExpanded) && (
              <IconBtnV2
                icon={openFilter ? <CloseIcon /> : <img src={FilterSort} alt="filter icon" />}
                onClick={() => setOpenFilter(!openFilter)}
                customStyle={styles.xsFilterButton(isFilteredArraysNotEmpty)}
              />
            )}
            <SearchBarToggle
              actionToDispatch={customerAdminSearchUsers}
              searchPlaceholder={t?.['Search for user by username or Email Address']}
              expandedState={searchBarExpanded}
              setExpandedState={setSearchBarExpanded}
              customStyle={styles.searchBar(searchBarExpanded)}
            />
          </Box>
        </Box>
      </Box>
      <DropDownBatchButton />
      <SummariesBtn
        actionToDispatch={customerAdminFilterBySummary}
        store={users}
        customStyle={styles.summaryBtn} />
    <FormModalContainer
      modalTitle={t?.['Filter By']}
      modalState={openFilter}
      handleClose={() => setOpenFilter(false)}
        customWidth={styles.filterForm}
        keepMounted
cancelText={t?.Close}
    >
        <Box sx={styles.filterBox} >
            <ActiveFilters
            store={users}
            actionToDispatch={customerAdminGetByUserTypes}
            customStyle={styles.activeFilter}
          />
        <SortByList
         actionToDispatch={customerAdminUsersSortBy}
          store={users}
        />

        <MenuListMultiSelect
            store={users}
            actionToDispatch={customerAdminGetByUserTypes}
            defaultValue={selectedUserTypes}
            refState={setSelectedUserTypes}
        />

      </Box>

      <OfoqThemeBtn
        name={`${t?.['Clear Filters']}`}
        onClick={handleClose}
        customStyle={styles.clearFilters}
      />

      </FormModalContainer>
    </Box>
  )
}

const styles = {
  employeeContainer: {
    display: { xs: 'flex', sm: 'none' },
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    p: '10px 5px',
  },
  firstRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: '10px',
    marginBottom: '10px',
    gap: { xs: '5px', sm: '10px' },
    '& img': {
      paddingRight: '5px',
    },
    '& span': {
      fontFamily: 'Avenir 85 light',
      fontWeight: 400,
      fontSize: { xs: '16px', sm: '24px' },
      lineHeight: { xs: '20.15px', sm: '37.08px' },
    },
    '& p': {
      margin: '0',
    },
  },
  searchSortFilter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    p: { xs: '10px 5px', sm: 'unset' },
  },
  searchBar: (isFiltered) => ({
    height: '35px',
    width: isFiltered ? '100%' : '35px',
    marginBottom: { xs: '10px', sm: '0px' },
  }),
  sortFilter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '20px',
  },
  filterWithSearch: {
    display: 'flex',
    gap: '5px',
    width: '100%',
    justifyContent: 'flex-end',
    '& img': {
      width: '20px',
      height: '20px',
    },
  },
  xsFilterButton: (isFiltered) => ({
    height: '35px',
    width: '35px',
    borderRadius: '10px',
    border: isFiltered ? '1px solid #29CC8B' : '1px solid #e2e8ee',
    backgroundColor: isFiltered ? 'white' : 'none',
    color: 'text.hint',
    overflow: 'hidden',
    '& img': {
      filter: isFiltered && 'brightness(0) saturate(100%) invert(60%) sepia(98%) saturate(331%) hue-rotate(90deg) brightness(91%) contrast(91%)',
    },
  }),
  activeFilter: {
    marginBottom: { xs: '10px', sm: '5px' },
    marginTop: { xs: '5px', sm: '0px' },
  },
  filterBox: {
    display: 'flex',
    gap: { xs: '5px', md: '23px' },
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
    marginTop: '20px',
  },
  sideButton: {
    width: '100%',
    textAlign: 'center',
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: '10px',
    margin: '1px -15px',
    marginLeft: '-15px',
    paddingTop: '8px',
    '&:hover': {
      backgroundColor: '#f7f9fb',
    },
  },
  option: {
    color: '#000000',
    textTransform: 'capitalize',
    minWidth: { xs: 'max-content', sm: '130px' },
    fontSize: { xs: '10px', sm: '16px' },
    margin: { xs: '0', sm: '5px 0' },
    padding: '0px',
    '& .MuiSvgIcon-root': {
      marginRight: { xs: '5px', sm: '7px' },
      width: { xs: '25px', sm: 'unset' },
      height: { xs: '25px', sm: 'unset' },
    },
    '& .MuiTypography-root': {
      fontSize: { xs: '11px', sm: '16px' },
    },
  },
  customCheckStyle: {
    width: '100%',
    padding: '0 5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  clearFilters: {
    width: { xs: '100%', sm: '0px' },
    maxWidth: { xs: '100%', md: '150px' },
    minWidth: { xs: '80px', sm: '0px' },
    height: { xs: '40px', sm: 'unset' },
  },
  summaryBtn: {
    marginTop: '10px',
    '& button': {
      fontWeight: 'bold',
    },
  },
}

export default Mobile
